import React from 'react';
import { UilTimes } from '@iconscout/react-unicons'
import imgCTA from '../../images/img_cta.png';

const ModalTalkExpert = () => {
  const closeModal = () => {
    document.getElementById('modal_talk_expert').classList.remove('show-cta-modal');
  };

  return (
    <div id="modal_talk_expert" className="modal-wrapper">
        <div className="modal-overlay-cta" onClick={closeModal}></div>
        <div className="modal-container">
            <div className="modal-content">
                <a className="modal-close" onClick={closeModal} aria-label="Close modal"><UilTimes/></a>
                <img src={imgCTA} alt="Talk to an Expert" />
                <h2>Talk to an Expert</h2>
                <p>How would you like to connect with us?</p>
                <a href="https://meetings-na2.hubspot.com/nigel30" rel="noopener noreferrer" target="_blank" className="btn-call-me">Call Me Now</a>
                <a href="https://meetings-na2.hubspot.com/nigel30" rel="noopener noreferrer" target="_blank" className="btn-schedule">Schedule Meeting</a>
            </div>
        </div>
    </div>
  );
};

export default ModalTalkExpert;